import { css } from "@emotion/react";

export const textarea = css`
  margin: 15px 0;
`;

export const textareaField = css`
  border-radius: 5px;
  height: 160px;
`;
